/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
export default class AchievementCategoryToggle extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const {
      collapsed
    } = this.attrs;
    return m(Button, {
      className: "Button Button--icon Button--link AchievementCategoryToggle",
      icon: collapsed() ? 'fas fa-chevron-down' : 'fas fa-chevron-up',
      onclick: () => collapsed(!collapsed())
    });
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/components/AchievementCategoryToggle', AchievementCategoryToggle);